import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ANALYTICS_NAMESPACE } from '@epicuro-next/constants/rule-engine/analytics-rules';
import { ReportingApiModule } from '@epicuro-next/data/reporting-api';
import { SignalRModule } from '@epicuro-next/data/signalr';
import { DataUsersModule } from '@epicuro-next/data/users';
import { ConfigurationModule } from '@epicuro-next/platform/configuration';
import { AccountsStateModule } from '@epicuro-next/state/accounts-state';
import { UserStateModule } from '@epicuro-next/state/user-state';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { ANALYTICS_ENTITIES_STATE_KEY } from './state';
import { initialState, reducer } from './state/analytics-entities.adapter';
import {
  AnalyticsBasketInsightsEffects,
  AnalyticsBestListsEffects,
  AnalyticsEntitiesEffects,
  AnalyticsSignalrEffects,
} from './state/effects';
import { AnalyticsLiveViewersEffects } from './state/effects/analytics-live-viewers.effects';
import { resetStateMetaReducer } from '@epicuro-next/state/meta-reducers';

@NgModule({
  imports: [
    CommonModule,
    ReportingApiModule,
    UserStateModule,
    ConfigurationModule.forFeature(ANALYTICS_NAMESPACE),
    EffectsModule.forFeature([
      AnalyticsEntitiesEffects,
      AnalyticsBestListsEffects,
      AnalyticsSignalrEffects,
      AnalyticsBasketInsightsEffects,
      AnalyticsLiveViewersEffects,
    ]),
    StoreModule.forFeature(ANALYTICS_ENTITIES_STATE_KEY, reducer, {
      metaReducers: [resetStateMetaReducer(initialState)],
    }),
    SignalRModule,
    AccountsStateModule,
    DataUsersModule,
  ],
})
export class AnalyticsEntitiesModule {}
